import { connect } from 'react-redux';

import ProgressWrapper from 'components/molecules/Fame/ProgressWrapper';
import { getProgressData } from 'store/mySuccess';
import { getBmi } from 'store/profile';

const mapStateToProps = (state) => ({
	...getProgressData(state),
	bmi: getBmi(state),
});

export default connect<any, any>(mapStateToProps)(ProgressWrapper as any);
